import { PageNotFoundEvent } from '@/services/analytics/events';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgPageNotFound',
})
export default class CmgPageNotFound extends Vue {
  routeNotFound = false;
  passThroughRoute = '';

  get slateRepeatableUrl(): string {
    return this.$appStore.state.cms.images.backgrounds.slate.default;
  }

  get page404Url(): string {
    return this.$appStore.state.cms.images.pageNotFound.default;
  }

  get arrowIcon(): string {
    return this.$appStore.state.cms.images.icons.arrowRight.default;
  }

  mounted() {
    // check to see if the current path is in our list of AEM paths that need to escape the router
    const path = window.location.pathname;
    const hash = window.location.hash;
    const hashString = hash.substring(1);
    const routedPaths = this.$services.config.getHeaderPages();
    const availableHashNames = ['common-questions', 'contact-support', 'make-a-suggestion'];
    
    if (routedPaths.includes(path) && !availableHashNames.includes(hashString)) {
      if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
        const urlStem = `${window.location.protocol}//${window.location.hostname}`;
        window.location.href = `${urlStem}${path}${hash}`;
      } else {
        // redirect to int rather than an empty local page
        window.location.href = `https://www-int.chipotle.com${path}${hash}`;
      }
    }

    this.$services.analytics.send(new PageNotFoundEvent());

    // only display the 404 page after we chech the path. no flashing the 404 before a redirect
    this.routeNotFound = true;
  }
}
